<template>
  <div class="home animate__animated animate__fadeIn">
    <!-- <div class="top">
         <div class="header">
             <div class="header_center">
                 <img src="@assets/img/logow.png" alt="" class="logo">
             </div>
         </div>
    </div>-->
    <!-- <div class="topp">-->
    <div id="menu">
      <div
        :class="headerFlag==true?'header':'headerChange'"
        id="animate_active"
        @mouseenter="enter"
        @mouseleave="leave"
      >
        <div class="header_center">
          <img :src="img1before" alt class="logo" @click="handleToHome" />
          <ul>
            <li
              :class="activeIndex==index?'activeItem':'beforeItem'"
              v-for="(item,index) in headerList"
              :key="index"
              @mouseenter="selected(index)"
              @click="handleChange(index)"
              refs="li"
            >
              <span>{{item.name}}</span>
            </li>
          </ul>
          <div class="header_right">
            <span class="division"></span>
            <img :src="img2before" class="sou" style=" cursor: pointer;" alt />
            <img :src="img3before" class="dao" style=" cursor: pointer;" @click="showAll" alt />
          </div>
        </div>
        <div class="nav" @mouseenter="navShow">
          <ul
            class="nav_ul"
            v-show="activeIndex==0?true:false"
            @mouseenter="navShow(activeIndex)"
            @mouseleave="navNone(activeIndex)"
            ref="navItem0"
          >
            <router-link
              tag="li"
              class="nav_li"
              :to="item.link"
              v-for="(item,index) in jieList"
              :key="index"
            >
              <span>{{item.name}}</span>
            </router-link>
          </ul>
          <ul
            class="nav_ul"
            v-show="activeIndex==1?true:false"
            @mouseenter="navShow(activeIndex)"
            @mouseleave="navNone(activeIndex)"
            ref="navItem1"
          >
            <li class="nav_li" :to="item.link" v-for="(item,index) in chanList" :key="index">
              <router-link tag="div" v-for="(it1,index) in item.title" :key="index" :to="it1.link">
                <span class="first_span">{{it1.name}}</span>
              </router-link>
              <router-link tag="div" :to="it.link" v-for="(it,index) in item.detail" :key="index">
                <span class="sec_span">{{it.name}}</span>
              </router-link>
            </li>
          </ul>
          <ul
            class="nav_ul"
            v-show="activeIndex==2?true:false"
            @mouseenter="navShow(activeIndex)"
            @mouseleave="navNone(activeIndex)"
            ref="navItem2"
          >
            <li class="nav_li" :to="item.link" v-for="(item,index) in ziList" :key="index">
              <router-link tag="div" v-for="(it1,index) in item.title" :key="index" :to="it1.link">
                <span class="first_span">{{it1.name}}</span>
              </router-link>
              <router-link tag="div" :to="it.link" v-for="(it,index) in item.detail" :key="index">
                <span class="sec_span">{{it.name}}</span>
              </router-link>
            </li>
          </ul>
          <ul
            class="nav_ul"
            v-show="activeIndex==3?true:false"
            @mouseenter="navShow(activeIndex)"
            @mouseleave="navNone(activeIndex)"
            ref="navItem3"
          >
            <li
              tag="li"
              class="nav_li"
              v-for="(item,index) in zhuanList"
              @click="handleZhuan(index)"
              :key="index"
            >{{item.name}}</li>
          </ul>
          <ul
            class="nav_ul"
            v-show="activeIndex==4?true:false"
            @mouseenter="navShow(activeIndex)"
            @mouseleave="navNone(activeIndex)"
            ref="navItem4"
          >
            <li
              tag="li"
              class="nav_li"
              v-for="(item,index) in liaoList"
              :key="index"
              @click="handleLiao(index)"
            >{{item.name}}</li>
          </ul>
          <ul
            class="nav_ul"
            v-show="activeIndex==5?true:false"
            @mouseenter="navShow(activeIndex)"
            @mouseleave="navNone(activeIndex)"
            ref="navItem5"
          >
            <router-link
              tag="li"
              class="nav_li"
              :to="item.link"
              v-for="(item,index) in jiaList"
              :key="index"
            >{{item.name}}</router-link>
          </ul>
        </div>
      </div>
    </div>

    <!-- 模态框 -->
    <transition name="modal">
      <div class="modal" v-if="modalFlag" style="z-index:1000">
        <div class="modal_center">
          <div class="modal_top">
            <img src="@assets/img/logow.png" @click="handleToHome" alt />
            <span
              class="iconfont cha"
              @click="handleClose"
              @mouseenter="zhuan"
              @mouseleave="zhuan"
              :class="{go:rotate , aa :!rotate}"
            >&#xe618;</span>
          </div>
          <div style="display:flex;justify-content:space-between">
            <ul class>
              <!-- <span v-for="(item,index) in headerList" :key="index">{{item.name}}</span> -->
              <span @click="handleJieSecond" class="title">解决方案</span>
              <router-link
                tag="li"
                class="nav_li"
                :to="item.link"
                v-for="(item,index) in jieList"
                :key="index"
              >
                <span>{{item.name}}</span>
              </router-link>
            </ul>
            <ul class>
              <!-- <span v-for="(item,index) in headerList" :key="index">{{item.name}}</span> -->
              <span @click="handleChanSecond">产品中心</span>
              <li class="nav_li" v-for="(ite,index) in chanList" :key="index">
                <router-link tag="div" v-for="(it1,index) in ite.title" :key="index" :to="it1.link">
                  <span>{{it1.name}}</span>
                </router-link>

                <!-- <span style="display:block">{{ite.name.theme}}</span> -->
                <!-- <span
                      style="display:block;text-indent:10px"
                      v-for="(chan,index) in ite.detail"
                      :key="index"
                >&nbsp;&nbsp;{{chan.name}}</span>-->
                <router-link
                  tag="div"
                  :to="it.link"
                  v-for="(it,index) in ite.detail"
                  :key="index"
                  style="display:block;text-indent:10px"
                >
                  &nbsp;&nbsp;
                  <span>{{it.name}}</span>
                </router-link>
              </li>
            </ul>
            <ul class>
              <!-- <span v-for="(item,index) in headerList" :key="index">{{item.name}}</span> -->
              <span @click="handleZiSecond">咨询服务</span>
              <li class="nav_li" :to="ite2.link" v-for="(ite2,index) in ziList" :key="index">
                <router-link
                  tag="div"
                  v-for="(it1,index) in ite2.title"
                  :key="index"
                  :to="it1.link"
                >
                  <span>{{it1.name}}</span>
                </router-link>
                <router-link
                  tag="div"
                  :to="it.link"
                  v-for="(it,index) in ite2.detail"
                  :key="index"
                  style="display:block;text-indent:10px"
                >
                  &nbsp;&nbsp;
                  <span>{{it.name}}</span>
                </router-link>
              </li>
            </ul>
            <ul class>
              <span @click="handleZhuanSecond">专长</span>
              <li v-for="(item,index) in zhuanList" :key="index" @click="handleZhuan(index)">
                <span>{{item.name}}</span>
              </li>
            </ul>
            <ul class>
              <span @click="handleLiaoSecond">了解我们</span>
              <li v-for="(item,index) in liaoList" :key="index" @click="handleLiao(index)">
                <span>{{item.name}}</span>
              </li>
            </ul>
            <!-- <ul class>
              <span>加入我们</span>
              <li v-for="(ite,index) in jiaList" :key="index">
                <span>{{ite.name}}</span>
              </li>
            </ul>-->
          </div>
        </div>
      </div>
    </transition>
    <!-- </div> -->
    <full-page :options="options" ref="fullpage" class="full">
      <div class="section section1">
        <div class="middle">
          <div class="font">集智广益，让世界更具活力</div>
          <div class="line"></div>
          <div class="letter">GATHER WISDOM AND BENEFIT, MAKE THE WORLD MORE ENERGETIC</div>
        </div>
      </div>
      <!-- 解决方案 -->
      <div class="section section2">
        <!-- <transition name="box"> -->
        <!-- @before-enter="handlebeforeEnter"
          @enter="handleEnter"
        @after-enter="handleafterEnter"-->

        <!-- :class="[{box:inAnimation},{box2:true}]"
            @animationend="inAnimation=false" 
        v-show="jsshow"-->
        <!-- <transition name="fade"> -->
        <div
          :class="[{box:inAnimation2},{box4:true},{animate__animated:true},{animate__fadeInDown:true}]"
          @animationend="inAnimation2=false"
          v-if="jie_index"
        >
          <div class="div1">解决方案</div>
          <div class="div2"></div>
          <div class="div3">
            连接现在与未来
            <br />专家跨学科合作研发，高效、增值的创新
            <br />型解决方案
          </div>
          <div class="div4 btn btn-2">
            <span @click="handleJieSecond">
              <!-- <svg>
        <rect x="0" y="0" fill="none" width="100%" height="100%"/>
              </svg>-->
              了解更多
              <span class="iconfont">&#xe608;</span>
            </span>
          </div>
        </div>
        <!-- </transition> -->
        <!-- </transition> -->
        <!-- 侧边导航栏 -->
        <div class="nav_list nav_list1">
          <li
            class="animate__animated animate__pulse"
            @mouseenter="handleTurnJie"
            @mouseleave="handleTurnJieIndex"
            :class="(activeNav==2)||(activeNav==4) ?'activeNameList1':''"
          >
            <a @click="handleZidong">
              <b :class="activeNav==1?'activeName1':''">
                <span>自动</span>
                <span>化</span>
              </b>
            </a>
          </li>
          <li
            @mouseenter="handleTurnWu"
            @mouseleave="handleTurnJieIndex"
            :class="(activeNav==2)||(activeNav==4) ?'activeNameList1':''"
          >
            <a @click="handlewulian">
              <b :class="activeNav==2?'activeName1':''">
                <span>物</span>
                <span class="span_right">联</span>
              </b>
            </a>
          </li>
          <li
            :class="(activeNav==2)||(activeNav==4) ?'activeNameList1':''"
            @mouseenter="handleTurnNeng"
            @mouseleave="handleTurnJieIndex"
          >
            <a @click="handleNengyuan">
              <b :class="activeNav==3?'activeName1':''">
                <span>能</span>
                <span class="span_right">源</span>
              </b>
            </a>
          </li>
          <li
            :class="(activeNav==2)||(activeNav==4) ?'activeNameList1':''"
            @mouseenter="handleTurnHuan"
            @mouseleave="handleTurnJieIndex"
          >
            <a @click="handleHuanjing">
              <b :class="activeNav==4?'activeName1':''">
                <span>环</span>
                <span class="span_right">境</span>
              </b>
            </a>
          </li>
        </div>
        <!-- 解决方案--自动化 -->
        <div
          class="jie_zidong jie_zidong1 animate__animated animate__fadeIn"
          ref="jie_zidong1"
          v-show="jie_zidongFlag"
        >
          <div class="jie_zidong_left wrap animate__animated animate__fadeIn">
            <!-- 立方体 -->
            <div class="cube">
              <div class="front">
                <img :src="jie_left" alt />
              </div>
              <div class="back">
                <!-- <img :src="jie_zidong" alt /> -->
              </div>
              <div class="top">
                <!-- <img :src="jie_zidong" alt /> -->
              </div>
              <div class="bottom">
                <img :src="jie_zidong" alt />
              </div>
              <!-- <div class="left">left</div>
              <div class="right">right</div>-->
            </div>
          </div>
          <div class="jie_zidong_right wrap animate__animated animate__fadeIn">
            <div class="cube cube_right">
              <div class="front">
                <img :src="jie_right" alt />
              </div>
              <div class="back">
                <img :src="jie_zidong" alt />
              </div>
              <div class="top top_zi" style="background: linear-gradient(0deg, #024F9B, #196CBB);">
                <div class="top_span">
                  <span class="font font1">自动化</span>
                  <span class="line line1"></span>
                  <span class="letter letter1">
                    尖端的技术，灵活的产品，丰富的
                    <br />经验，帮助企业走向可持续发展的
                    <br />未来
                  </span>
                </div>
              </div>
              <div class="bottom"></div>
            </div>
          </div>
        </div>
        <!-- 解决方案--物联 -->
        <div
          class="jie_zidong jie_wulian animate__animated animate__fadeIn"
          ref="jie_wulian"
          v-show="jie_wulianFlag"
        >
          <div class="jie_zidong_left wrap animate__animated animate__fadeIn">
            <!-- 立方体 -->
            <div class="cube cube_wulianLeft">
              <div class="front">
                <img :src="jie_left" alt />
              </div>
              <div class="back">
                <img :src="jie_wulian" alt />
              </div>
              <div class="top">
                <img :src="jie_wulian" alt />
              </div>
              <div class="bottom">
                <img :src="jie_wulian" alt />
              </div>
              <div class="left" style>
                <img :src="jie_wulian" alt />
              </div>
              <div class="right">right</div>
            </div>
          </div>
          <div class="jie_zidong_right wrap animate__animated animate__fadeIn">
            <div class="cube cube_wulianRight">
              <div class="front">
                <img :src="jie_right" alt />
              </div>
              <div class="back">
                <img :src="jie_zidong" alt />
              </div>
              <!-- <div class="top"></div> -->
              <!-- <div class="bottom"></div> -->
              <div class="left"></div>
              <div class="right" style="background:white">
                <div class="top_span">
                  <span class="font font1" style="color:rgba(51,51,51,1);">物联</span>
                  <span class="line line1"></span>
                  <span class="letter letter1">
                    改变企业思维模式，实现降低能耗
                    <br />控制生产，提高品质的长久运营
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 解决方案--能源 -->
        <div
          class="jie_zidong jie_nengyuan animate__animated animate__fadeIn"
          ref="jie_nengyuan"
          v-show="jie_nengyuanFlag"
        >
          <div class="jie_zidong_left wrap animate__animated animate__fadeIn">
            <!-- 立方体 -->
            <div class="cube">
              <div class="front">
                <img :src="jie_left" alt />
              </div>
              <div class="back">
                <!-- <img :src="jie_nengyuan" alt /> -->
              </div>
              <div class="top">
                <!-- <img :src="jie_nengyuan" alt /> -->
              </div>
              <div class="bottom">
                <img :src="jie_nengyuan" alt />
              </div>
            </div>
          </div>
          <div class="jie_zidong_right wrap animate__animated animate__fadeIn">
            <div class="cube cube_right">
              <div class="front">
                <img :src="jie_right" alt />
              </div>
              <div class="back">
                <img :src="jie_zidong" alt />
              </div>
              <div class="top" style="background: linear-gradient(0deg, #024F9B, #196CBB);">
                <div class="top_span">
                  <span class="font font1">能源</span>
                  <span class="line line1"></span>
                  <span class="letter letter1">
                    多学科技术与产品的完美融合，优
                    <br />化工厂运营的能源供应和能源需求
                  </span>
                </div>
              </div>
              <div class="bottom"></div>
            </div>
          </div>
        </div>
        <!-- 解决方案--环境 -->
        <div
          class="jie_zidong jie_huanjing animate__animated animate__fadeIn"
          ref="jie_nengyuan"
          v-show="jie_huanjingFlag"
        >
          <div class="jie_zidong_left wrap animate__animated animate__fadeIn">
            <!-- 立方体 -->
            <div class="cube cube_wulianLeft">
              <div class="front">
                <img :src="jie_left" alt />
              </div>
              <div class="back">
                <img :src="jie_huanjing" alt />
              </div>
              <div class="top">
                <img :src="jie_huanjing" alt />
              </div>
              <div class="bottom">
                <img :src="jie_huanjing" alt />
              </div>
              <div class="left" style>
                <img :src="jie_huanjing" alt />
              </div>
              <div class="right">right</div>
            </div>
          </div>
          <div class="jie_zidong_right wrap animate__animated animate__fadeIn">
            <div class="cube cube_wulianRight">
              <div class="front">
                <img :src="jie_right" alt />
              </div>
              <div class="back">
                <img :src="jie_huanjing" alt />
              </div>
              <!-- <div class="top"></div>
              <div class="bottom"></div>-->
              <div class="left"></div>
              <div class="right" style="background:white">
                <div class="top_span">
                  <span class="font font1">环境</span>
                  <span class="line line1"></span>
                  <span class="letter letter1">
                    通过监测技术和节能降耗方案，降
                    <br />低环境损害，提高企业的盈利空间
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 解决方案--首页 -->
      </div>
      <!-- 产品中心 -->
      <div class="section section3">
        <!-- <transition name="box" @before-enter="beforeEnter" @enter="enter" @leave="leave"> -->
        <div
          :class="[{box:inAnimation3},{box3:true},{animate__animated:true},{animate__fadeInDown:true}]"
          @animationend="inAnimation3=false"
          v-if="chan_index"
        >
          <div class="div1">产品中心</div>
          <div class="div2"></div>
          <div class="div3">
            创新和品质始于传统研究与开发
            <br />更灵活、更安全、更智能产品组合，帮助客户简化流程
            <br />提高生产率以及优化成本
          </div>
          <div class="div4 btn btn-2">
            <span @click="handleChanSecond">
              了解更多
              <span class="iconfont">&#xe608;</span>
            </span>
          </div>
        </div>
        <!-- </transition> -->
        <!-- 侧边导航栏 -->
        <div class="nav_list nav_list2">
          <div
            @mouseenter="handleTurnRuan"
            @mouseleave="handleTurnChanIndex"
            :class="(activeNav==2)?'activeNameList2':''"
          >
            <a @click="handleChanGongruan" style="cursor:pointer">
              <b :class="activeNav==1?'activeName2':''">
                <span style="cursor:pointer">工业软件</span>
              </b>
            </a>
          </div>
          <br />
          <div
            @mouseenter="handleTurnWuXian"
            @mouseleave="handleTurnChanIndex"
            :class="(activeNav==2)?'activeNameList2':''"
          >
            <a @click="handleChanGongwu" style="cursor:pointer">
              <b :class="activeNav==2?'activeName2':''">
                <span style="cursor:pointer">工业无线</span>
                <!-- <span class="span_right">联</span> -->
              </b>
            </a>
          </div>
          <br />
          <div
            :class="(activeNav==2)?'activeNameList2':''"
            @mouseenter="handleTurnYi"
            @mouseleave="handleTurnChanIndex"
          >
            <a @click="handleChanCe" style="cursor:pointer">
              <b :class="activeNav==3?'activeName2':''">
                <span style="cursor:pointer">仪器仪表</span>
                <!-- <span class="span_right">源</span> -->
              </b>
            </a>
          </div>
        </div>
        <!-- 产品中心--工业软件 -->
        <div
          class="jie_zidong chan_ruanjian animate__animated animate__fadeIn"
          v-if="chan_gongFlag"
        >
          <div class="jie_zidong_left wrap animate__animated animate__fadeIn">
            <!-- 立方体 -->
            <div class="cube">
              <div class="front">
                <img :src="chan_left" alt />
              </div>
              <div class="back">
                <img :src="jie_zidong" alt />
              </div>
              <div class="top"></div>
              <div
                class="bottom"
                style="background:linear-gradient(0deg,rgba(0,91,90,1),rgba(136,176,127,1));"
              >
                <div class="top_span_left">
                  <span class="font font2">工业软件</span>
                  <span class="line line2"></span>
                  <span class="letter letter2">
                    <span>通过数据的收集和分析，让您的制</span>
                    <br />
                    <span>造流程更透明，为运营和服务创造</span>
                    <br />
                    <span>附加值。</span>
                  </span>
                </div>
              </div>
              <div class="left">left</div>
              <div class="right">right</div>
            </div>
          </div>
          <div class="jie_zidong_right wrap animate__animated animate__fadeIn">
            <div class="cube cube_right">
              <div class="front">
                <img :src="chan_right" alt />
              </div>
              <div class="back">
                <!-- <img :src="chan_gong" alt /> -->
              </div>
              <div class="top">
                <img :src="chan_gong" alt />
              </div>
              <div class="bottom">
                <!-- <img :src="chan_gong" alt /> -->
              </div>
              <!-- <div class="left">left</div>
              <div class="right">right</div>-->
            </div>
          </div>
        </div>
        <!-- 产品中心--工业无线 -->
        <div
          class="jie_zidong chan_wuxian animate__animated animate__fadeIn"
          v-if="chan_wuxianFlag"
        >
          <div class="jie_zidong_left wrap animate__animated animate__fadeIn">
            <!-- 立方体 -->
            <div class="cube cube_right cube_wulianLeft">
              <div class="front">
                <img :src="jie_right" alt />
              </div>
              <div class="back">
                <img :src="jie_zidong" alt />
              </div>
              <div class="top"></div>
              <div class="bottom"></div>
              <div class="left" style="background:white">
                <div class="top_span_left">
                  <span class="font font2" style="color:rgba(51,51,51,1);">工业无线</span>
                  <span class="line line2"></span>
                  <span class="letter letter2" style="color:rgba(51,51,51,1);">
                    监测并收录所有生产层面的过程信
                    <br />息，确保在整个过程中保持最佳性
                    <br />能。
                  </span>
                </div>
              </div>
              <div class="right"></div>
            </div>
          </div>
          <div class="jie_zidong_right wrap animate__animated animate__fadeIn">
            <div class="cube cube_wulianRight">
              <div class="front">
                <img :src="chan_left" alt />
              </div>
              <div class="back">
                <img :src="chan_wuxian" alt />
              </div>
              <!-- <div class="top">
                <img :src="chan_wuxian" alt />
              </div>
              <div class="bottom">
                <img :src="chan_wuxian" alt />
              </div>-->
              <!-- <div class="left" style>
                <img :src="chan_wuxian" alt />
              </div>-->
              <div class="right">
                <img :src="chan_wuxian" alt />
              </div>
            </div>
          </div>
        </div>
        <!-- 产品中心--仪器仪表 -->
        <div class="jie_zidong chan_yiqi animate__animated animate__fadeIn" v-if="chan_yiqiFlag">
          <div class="jie_zidong_left wrap animate__animated animate__fadeIn">
            <!-- 立方体 -->
            <div class="cube">
              <div class="front">
                <img :src="chan_left" alt />
              </div>
              <div class="back">
                <img :src="jie_zidong" alt />
              </div>
              <div class="top"></div>
              <div
                class="bottom"
                style="background:linear-gradient(0deg,rgba(0,91,90,1),rgba(136,176,127,1));"
              >
                <div class="top_span_left">
                  <span class="font font2">仪器仪表</span>
                  <span class="line line2"></span>
                  <span class="letter letter2">
                    精准的参数采集，有利于工厂的效
                    <br />率和品质的快速提升。
                  </span>
                </div>
              </div>
              <div class="left">left</div>
              <div class="right">right</div>
            </div>
          </div>
          <div class="jie_zidong_right wrap animate__animated animate__fadeIn">
            <div class="cube cube_right">
              <div class="front">
                <img :src="chan_right" alt />
              </div>
              <div class="back">
                <!-- <img :src="chan_yiqi" alt /> -->
              </div>
              <div class="top">
                <img :src="chan_yiqi" alt />
              </div>
              <div class="bottom">
                <!-- <img :src="chan_yiqi" alt /> -->
              </div>
              <!-- <div class="left">left</div>
              <div class="right">right</div>-->
            </div>
          </div>
        </div>
        <!-- 产品中心--首页 -->
      </div>
      <!-- 咨询服务 -->
      <div class="section section4">
        <div
          :class="[{box:inAnimation4},{box4:true},{animate__animated:true},{animate__fadeInDown:true}]"
          @animationend="inAnimation4=false"
          id="nextS"
          v-if="zi_index"
        >
          <div class="div1">咨询服务</div>
          <div class="div2"></div>
          <div class="div3">
            专注各自擅长的领域
            <br />提供可用性、盈利能力和安全性的咨
            <br />询、服务和技术
          </div>
          <div class="div4 btn btn-2">
            <span @click="handleZiSecond">
              了解更多
              <span class="iconfont">&#xe608;</span>
            </span>
          </div>
        </div>
        <!-- 侧标导航栏 -->
        <div class="nav_list nav_list1">
          <li
            class="animate__animated animate__pulse"
            @mouseenter="handleTurnZi"
            @mouseleave="handleTurnZiIndex"
            :class="(activeNav==2) ?'activeNameList1':''"
          >
            <a @click="handleZixun">
              <b :class="activeNav==1?'activeName1':''">
                <span style="cursor:pointer">咨询</span>
              </b>
            </a>
          </li>
          <li
            @mouseenter="handleTurnFu"
            @mouseleave="handleTurnZiIndex"
            :class="(activeNav==2) ?'activeNameList1':''"
          >
            <a @click="handleFuwu">
              <b :class="activeNav==2?'activeName1':''">
                <span style="cursor:pointer">服务</span>
              </b>
            </a>
          </li>
        </div>
        <!--咨询服务--咨询 -->
        <div class="jie_zidong zi_zixun animate__animated animate__fadeIn" v-if="zi_zixunFlag">
          <div class="jie_zidong_left wrap animate__animated animate__fadeIn">
            <!-- <img :src="jie_zidong" alt /> -->
            <!-- 立方体 -->
            <div class="cube">
              <div class="front">
                <img :src="zi_left" alt />
              </div>
              <div class="back">
                <!-- <img :src="zi_zi" alt /> -->
              </div>
              <div class="top">
                <!-- <img :src="zi_zi" alt /> -->
              </div>
              <div class="bottom">
                <img :src="zi_zi" alt />
              </div>
              <!-- <div class="left">left</div>
              <div class="right">right</div>-->
            </div>
          </div>
          <div class="jie_zidong_right wrap animate__animated animate__fadeIn">
            <div class="cube cube_right">
              <div class="front">
                <img :src="zi_right" alt />
              </div>
              <div class="back">
                <img :src="zi_zi" alt />
              </div>
              <div class="top" style="background:linear-gradient(0deg, #C51632, #D95E39);">
                <div class="top_span">
                  <span class="font font3">咨询</span>
                  <span class="line line3"></span>
                  <span class="letter letter3">
                    尖端技术加上高度灵活的方式方法
                    <br />与客户在项目的各个阶段实现通力
                    <br />合作，提供可靠保障。无论是新建
                    <br />或者改造，我们都与客户携手，定
                    <br />制理想的解决方案。
                  </span>
                </div>
              </div>
              <div class="bottom"></div>
              <!-- <div class="left">left</div> -->
              <!--  <div class="right">right</div>-->
            </div>
          </div>
        </div>
        <!-- 咨询服务--服务 -->
        <div class="jie_zidong zi_fuwu animate__animated animate__fadeIn" v-if="zi_fuwuFlag">
          <div class="jie_zidong_left wrap animate__animated animate__fadeIn">
            <!-- 立方体 -->
            <div class="cube cube_wulianLeft">
              <div class="front">
                <img :src="zi_left" alt />
              </div>
              <div class="back">
                <img :src="zi_fu" alt />
              </div>
              <div class="top">
                <img :src="zi_fu" alt />
              </div>
              <div class="bottom">
                <img :src="zi_fu" alt />
              </div>
              <div class="left" style>
                <img :src="zi_fu" alt />
              </div>
              <div class="right">right</div>
            </div>
          </div>
          <div class="jie_zidong_right wrap animate__animated animate__fadeIn">
            <div class="cube cube_right cube_wulianRight">
              <div class="front">
                <img :src="zi_right" alt />
              </div>
              <div class="back">
                <img :src="zi_right" alt />
              </div>
              <!-- <div class="top"></div>
              <div class="bottom"></div>-->
              <!-- <div class="left"></div> -->
              <div class="right" style="background:white">
                <div class="top_span">
                  <span class="font font1" style="color:rgba(51,51,51,1);">服务</span>
                  <span class="line line1"></span>
                  <span class="letter letter1" style="color:rgba(51,51,51,1);">
                    我们提供可扩展的项目交付方法和
                    <br />完善的项目管理服务，不局限安装
                    <br />校准、维护和更换机器和系统，从
                    <br />驱动器系统实施到完整的逻辑网络
                    <br />实施再到整个系统的现代化，我们
                    <br />都能做到。
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--咨询服务--首页 -->
      </div>
      <!-- <div class="section footerss">
        <footer class="footer" id="footer"></footer>
      </div>-->
      <div class="section section5 bottom_content footerss fp-auto-height">
        <div class="footer" id="footer">
          <div class="bottom_border">
            <div class="bottom_center">
              <ul class>
                <li @click="handleJieSecond" class="foot_title">解决方案</li>
                <router-link
                  tag="li"
                  class="nav_li"
                  :to="item.link"
                  v-for="(item,index) in jieList"
                  :key="index"
                >
                  <span>{{item.name}}</span>
                </router-link>
              </ul>
              <ul>
                <li @click="handleChanSecond">产品中心</li>
                <li class="nav_li" v-for="(ite,index) in chanList" :key="index">
                  <router-link
                    tag="div"
                    v-for="(it1,index) in ite.title"
                    :key="index"
                    :to="it1.link"
                  >
                    <span>{{it1.name}}</span>
                  </router-link>
                </li>
              </ul>
              <ul class>
                <!-- <span v-for="(item,index) in headerList" :key="index">{{item.name}}</span> -->
                <li @click="handleZiSecond">咨询服务</li>
                <li class="nav_li" :to="ite2.link" v-for="(ite2,index) in ziList" :key="index">
                  <router-link
                    tag="div"
                    :to="it.link"
                    v-for="(it,index) in ite2.detail"
                    :key="index"
                    class="zixun"
                  >
                    <span>{{it.name}}</span>
                  </router-link>
                </li>
              </ul>
              <ul class>
                <li @click="handleZhuanSecond" class="zhuanchang">专长</li>
                <li v-for="(item,index) in zhuanList" :key="index" @click="handleZhuan(index)">
                  <span>{{item.name}}</span>
                </li>
              </ul>
              <ul class>
                <li @click="handleLiaoSecond">了解我们</li>
                <li v-for="(item,index) in liaoList" :key="index" @click="handleLiao(index)">
                  <span>{{item.name}}</span>
                </li>
              </ul>
              <!-- <ul class>
                <li>加入我们</li>
                <li v-for="(ite,index) in jiaList" :key="index">
                  <span>{{ite.name}}</span>
                </li>
              </ul>-->
            </div>
          </div>
          <div class="contact">
            <div class="contact_center">
              <div class="font">联系方式</div>
              <div class="contact_phone">
                <div class="contact_phone1">
                  <img src="@assets/img/dianhua.png" alt />
                  <span class="phone1">0571-88331233</span>
                  <img class="chuanzhen" src="@assets/img/youxiang.png" alt />
                  <span>310021</span>
                </div>
                <div class="contact_phone2">
                  <img class="chuanzhen" src="@assets/img/chuanzhen.png" alt />
                  <span class="phone2">0571-88331244</span>
                  <img class="dizhi" src="@assets/img/dizhi.png" alt />
                  <span>浙江省杭州市江干区天城路68号万事利科技大厦A座9层</span>
                </div>
              </div>
              <div class="image_er">
                <img :src="erweima" alt class="erweima" />
              </div>
            </div>
          </div>
          <div class="power">
            <span>版权所有： © 2019 谱恒高科技有限责任公司 <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#fff;">浙ICP备15043944号-1</a></span>
          </div>
        </div>
      </div>
    </full-page>
  </div>
</template>

<script>
export default {
  name: "Home",
  inject: ["reload"],
  data() {
    return {
      options: {
        // 为每个section设置背景色
        //sectionsColor: ["#f00","#0f0","#00f"],
        //用来控制slide幻灯片的箭头，设置为false，两侧的箭头会消失
        controlArrows: false,
        //每一页幻灯片的内容是否垂直居中
        //verticalCentered: false,
        //字体是否随着窗口缩放而缩放
        //resize: true,
        //页面滚动速度
        scrollingSpeed: 700,
        //定义锚链接，用户可以快速打开定位到某一页面；不需要加"#"，不要和页面中任意的id和name相同
        // anchors: ["page1","page2","page3","page4","page5"],
        //是否锁定锚链接
        //lockAnchors: true,
        //定义section页面的滚动方式，需要引入jquery.easings插件
        //easing:,
        //是否使用css3 transform来实现滚动效果
        // css3: false,
        //滚动到最顶部后是否连续滚动到底部
        //loopTop: true,
        //滚动到最底部后是否连续滚动到顶部
        //loopBottom: true,
        //横向slide幻灯片是否循环滚动
        loopHorizontal: false,
        //是否循环滚动，不会出现跳动，效果很平滑
        //continuousVertical: true,
        //是否使用插件滚动方式，设为false后，会出现浏览器自带的滚动条，将不会按页滚动
        //autoScrolling: false,
        //是否包含滚动条，设为true，则浏览器自带的滚动条会出现，页面还是按页滚动，但是浏览器滚动条默认行为也有效
        //scrollBar: true,
        //设置每个section顶部的padding，当我们要设置一个固定在顶部的菜单、导航、元素等时使用
        //paddingTop: "100px",
        //设置每个section底部的padding，当我们要设置一个固定在底部的菜单、导航、元素等时使用
        // paddingBottom: "100px",
        //固定的元素，为jquery选择器；可用于顶部导航等
        // fixedElements: ".header",
        //是否可以使用键盘方向键导航
        //keyboardScrolling: false,
        //在移动设置中页面敏感性，最大为100，越大越难滑动
        //touchSensitivity: 5,
        //设为false，则通过锚链接定位到某个页面不再有动画效果
        //animateAnchor: false,
        //是否记录历史，可以通过浏览器的前进后退来导航
        //recordHistory: true,
        //绑定菜单，设定相关属性和anchors的值对应后，菜单可以控制幻灯片滚动
        //是否显示导航，设为true会显示小圆点作为导航
        //navigation: true,
        //导航小圆点的位置，可以设置为left或者right
        //navigationPosition: right,
        //鼠标移动到小圆点上时显示出的提示信息
        //navigationTooltips: ["第一页","第二页","第三页"],
        //是否显示当前页面小圆点导航的提示信息，不需要鼠标移上
        //showActiveTooltip: true,
        //是否显示横向幻灯片的导航
        //slidesNavigation: true,
        //横向幻灯片导航的位置，可以为top或者bottom
        //slidesNavPosition: bottom,
        //内容超过满屏时是否显示滚动条，需要jquery.slimscroll插件
        //scrollOverflow: true,
        //section选择器
        //sectionSelector: ".section",
        //slide选择器
        //slideSelector: ".slide"
        licenseKey: null,
        onLeave: this.onLeave,
        afterLoad: this.afterLoad,
        scrollOverflow: true,
        scrollBar: false,

        verticalCentered: false,
        rerize: true,
        // navigation:true,
        menu: "#menu",
        // navigation: true,
        // anchors: ["page1", "page2", "page3", "page4", "footerl"],
        // sectionsColor: [
        //   "#41b883",
        //   "#ff5f45",
        //   "#0798ec",
        //   "#fec401",
        //   "#1bcee6",
        //   "#ee1a59",
        //   "#2c3e4f",
        //   "#ba5be9",
        //   "#b4b8ab",
        // ],
      },
      headerList: [
        { name: "解决方案", url: "solution" },
        { name: "产品中心", url: "productCenter" },
        { name: "咨询服务", url: "consulting" },
        { name: "专长", url: "expertise" },
        { name: "了解我们", url: "knowus" },
        // { name: "加入我们", url: "home" },
      ],
      jieList: [
        { name: "自动化", link: "automation" },
        { name: "物联", link: "iot" },
        { name: "能源", link: "energy" },
        { name: "环境", link: "environmental" },
      ],
      chanList: [
        {
          title: [{ name: "工业无线", link: "industrialWir" }],
          detail: [
            { name: "无线网络", link: "industrialWir" },
            { name: "无线通讯", link: "industrialWir" },
            { name: "无线位置", link: "industrialWir" },
            { name: "无线分析", link: "industrialWir" },
          ],
        },
        {
          title: [{ name: "工业软件", link: "industrialSoft" }],
          detail: [
            { name: "能源管理软件", link: "industrialSoft" },
            { name: "大数据平台", link: "industrialSoft" },
            { name: "GIS地图信息平台", link: "industrialSoft" },
          ],
        },
        {
          title: [{ name: "仪器仪表", link: "measuring" }],
          detail: [
            { name: "流体仪表", link: "measuring" },
            { name: "电力仪表", link: "measuring" },
            { name: "压力仪表", link: "measuring" },
            { name: "温度仪表", link: "measuring" },
            { name: "液位仪表", link: "measuring" },
          ],
        },
      ],
      ziList: [
        {
          title: [{ name: "咨询", link: "consultSer" }],
          detail: [
            { name: "智能工厂咨询服务", link: "intellFactory" },
            { name: "工业物联园区咨询服务", link: "iotPark" },
          ],
        },
        {
          title: [{ name: "服务", link: "servicing" }],
          detail: [
            { name: "设备安装与运维服务", link: "install" },
            { name: "数据分析与校准服务", link: "dataAnalysis" },
            // { name: "能源与能效诊断服务", link: "" },
          ],
        },
      ],
      zhuanList: [
        { name: "综合介绍", link: "" },
        { name: "能源", link: "" },
        { name: "流体计量", link: "" },
        { name: "数据分析与校准服务", link: "" },
      ],
      liaoList: [
        { name: "企业概述", link: "" },
        { name: "企业文化", link: "" },
        { name: "荣誉资质", link: "" },
        { name: "新闻报告", link: "" },
        { name: "合作伙伴", link: "" },
      ],
      jiaList: [
        { name: "社会招聘", link: "" },
        { name: "校园招聘", link: "" },
      ],
      headerFlag: true,
      img1before: require("@assets/img/logow.png"),
      img2before: require("@assets/img/souw.png"),
      img3before: require("@assets/img/daow.png"),
      activeIndex: -1,
      modalFlag: false,
      rotate: false, //控制互转效果
      activeNav: -1, //二级侧边导航点亮
      erweima: require("@assets/img/erma.png"),

      jie_left: require("@assets/img/banner2_left.jpg"),
      jie_right: require("@assets/img/banner2_right.jpg"),
      jie_zidong: require("@assets/img/jie_zidong.jpg"),
      jie_zidongFlag: false, //解决方案--自动化
      jie_wulianFlag: false, //解决方案--物联
      jie_wulian: require("@assets/img/jie_wu.jpg"),
      jie_nengyuanFlag: false, //解决方案--能源
      jie_nengyuan: require("@assets/img/jie_nengyuan.jpg"),
      jie_huanjingFlag: false, //解决方案--环境
      jie_huanjing: require("@assets/img/jie_huanjing.jpg"),
      jie_index: true, //解决方案--首页
      timer: "",
      chan_gongFlag: false, //产品中心--工业软件
      chan_left: require("@assets/img/banner3_left.jpg"),
      chan_right: require("@assets/img/banner3_right.jpg"),
      chan_gong: require("@assets/img/chan_gong.jpg"),

      chan_wuxianFlag: false, //产品中心--工业无线
      chan_wuxian: require("@assets/img/chan_wuxian.jpg"),

      chan_yiqiFlag: false, //产品中心--仪器仪表
      chan_yiqi: require("@assets/img/chan_yiqi.jpg"),

      chan_index: true, //产品中心--首页

      zi_zixunFlag: false, //咨询服务--咨询
      zi_left: require("@assets/img/banner4_left.jpg"),
      zi_right: require("@assets/img/banner4_right.jpg"),
      zi_zi: require("@assets/img/zi_zi.jpg"),

      zi_fuwuFlag: false, //咨询服务--服务
      zi_fu: require("@assets/img/zi_fu.jpg"),

      zi_index: true, //咨询服务--首页

      inAnimation2: false, //box动画标志
      inAnimation3: false, //box动画标志
      inAnimation4: false, //box动画标志
      jsshow: false,

      img1: require("@assets/img/banner1.jpg"),
    };
  },
  created() {
    // this.handleSlide();
  },
  mounted() {
    window.addEventListener("keyup", this.handleKeyup);
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleToHome() {
      //点击图片跳转到首页
      this.modalFlag = false;
      this.$router.push("/");
      this.reload();
    },
    enter: function () {
      this.headerFlag = false;
      this.img1before = require("@assets/img/logob.png");
      this.img2before = require("@assets/img/soub.png");
      this.img3before = require("@assets/img/daob.png");
      this.activeIndex = -1;
    },
    leave: function () {
      this.headerFlag = true;
      this.img1before = require("@assets/img/logow.png");
      this.img2before = require("@assets/img/souw.png");
      this.img3before = require("@assets/img/daow.png");
      this.activeIndex = -1;
    },
    selected(index) {
      this.activeIndex = index;
      // console.log(this.activeIndex);
    },
    //跳转头部相应页面
    handleChange(index) {
      this.$router.push(this.headerList[index].url);
    },
    // 点击头部-专长
    handleZhuan(index) {
       sessionStorage.setItem("expertise", index );
      this.$router.push({ name: "Expertise", params: { tab: index } });
    },
    // 点击头部-了解我们
    handleLiao(index) {
       sessionStorage.setItem("knowus", index);
      this.$router.push({ name: "Knowus", params: { tab: index } });
    },
    navShow() {
      // console.log(index);
      // switch (index){
      //   case 0:
      //      this.$refs.navItem0.style.display="block";
      //      break;
      //   case 1:
      //      this.$refs.navItem1.style.display="block";
      //      break;
      //   case 2:
      //      this.$refs.navItem2.style.display="block";
      //      break;
      //   case 3:
      //      this.$refs.navItem3.style.display="block";
      //      break;
      //   case 4:
      //      this.$refs.navItem4.style.display="block";
      //      break;
      //   case 5:
      //      this.$refs.navItem5.style.display="block";
      //      break;
      // }
    },
    navNone() {},
    onLeave(index, nextIndex) {
      // console.log(index, nextIndex, direction);
      switch (nextIndex.index) {
        case 1:
          this.inAnimation2 = true;
          break;
        case 2:
          this.inAnimation3 = true;
          break;
        case 3:
          this.inAnimation4 = true;
          break;
      }
    },
    afterLoad(index) {
      // console.log(index);
      if (index.index == 1) {
        // this.jsshow = true;
        // this.inAnimation = true;
        //翻转到解决方案那一页的时候
        // this.handleSlide();
        // this.handleTurnJie();
        // this.$refs.fullpage.api.setScrollingSpeed(10000);
        // this.$refs.fullpage.api.silentMoveTo(4)
      }
      if (index.index == 2) {
        // this.inAnimation = true;
      }
      if (index.index == 3) {
        // this.inAnimation = true;
      }
      // if(index==3){
      //   console.log("滑到底部了")
      //     this.$refs.fullpage.api.setAllowScrolling(false, 'down');
      // }
      // if (index.index == 3) {
      //   // alert("滑到底部");
      //   // this.options.serAutoScrolling(false)
      //   this.$refs.fullpage.api.setAutoScrolling(false);
      //   // this.$refs.fullpage.api.scrollOverflow(false);
      //   let start =
      //     document.documentElement.scrollTop ||
      //     document.body.scrollTop ||
      //     window.pageYOffset; //要做兼容 在模拟器能正常获取scrolltop在微信h5页面和手机的浏览器页面一直为0
      //   // let last = 0;
      //   window.addEventListener("scroll", function () {
      //     // 获得页面实时滚动的位置
      //     // let end =
      //     //   document.documentElement.scrollTop ||
      //     //   document.body.scrollTop ||
      //     //   window.pageYOffset; //要做兼容 在模拟器能正常获取scrolltop在微信h5页面和手机的浏览器页面一直为0
      //     // // 如滚动的位置小于0，则代表页面在倒数第二屏向上滚，这个时候再改变页面的滚动方式
      //     let end =document.documentElement.scrollHeight||document.body.scrollHeight
      //     console.log(start)
      //     console.log(end)
      //     // if (end - start==0) {
      //       // this.$refs.fullpage.api.setAutoScrolling(true);
      //         // this.$refs.fullpage.api.scrollOverflow(false);
      //     // }
      //   });}

      //  // 当页面滚动到倒数第二屏时，改变页面滚动方式
      //            this.$refs.fullpage.api.setAutoScrolling(false);
      //             // 记录页面开始滚动的位置
      //          let start =  document.documentElement.scrollTop ||
      //   document.body.scrollTop ||
      //   window.pageYOffset; //要做兼容 在模拟器能正常获取scrolltop在微信h5页面和手机的浏览器页面一直为0
      // // // let last = 0;
      //             // let last = 0;
      //           window.addEventListener("scroll", function () {
      //                 // 获得页面实时滚动的位置
      //                 let end = document.documentElement.scrollTop ||
      //     document.body.scrollTop ||
      //     window.pageYOffset; //要做兼容 在模拟器能正常获取scrolltop在微信h5页面和手机的浏览器页面一直为0
      //                 // 如滚动的位置小于0，则代表页面在倒数第二屏向上滚，这个时候再改变页面的滚动方式
      //                 if (end - start < 0) {
      //                    this.$refs.fullpage.api.setAutoScrolling(true);
      //                 }
      //             })

      // }
    },
    showAll() {
      //打开弹窗
      //点击右上角三条横杠
      this.modalFlag = true;
      // var mo=function(e){e.preventDefault();};
      //   document.body.style.overflow='hidden';
      //   document.addEventListener("touchmove",mo,false);//禁止页面滑动
      this.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
    },
    handleClose() {
      //关闭弹窗
      this.modalFlag = false;
      this.$refs.fullpage.api.setAllowScrolling(true, "up,down,left, right");
    },
    zhuan() {
      //旋转模态框叉号
      this.rotate = !this.rotate;
    },
    handleTurnJie() {
      //解决方案--自动化
      //滑上解决方案的查看更多div
      var _me = this;
      // setTimeout(function () {
      _me.jie_zidongFlag = true;
      _me.jie_wulianFlag = false;
      _me.jie_nengyuanFlag = false;
      _me.jie_huanjingFlag = false;
      _me.jie_index = false;
      _me.activeNav = 1;
      _me.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
      // _me.$refs.jie_zidong1.style.zIndex=10
      // _me.$refs.jie_wulian.style.zIndex=5
      // }, 1000);
      // this.jie_zidongFlag = true;
      // this.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
    },
    handleTurnWu() {
      //解决方案--物联
      var _me = this;
      // setTimeout(function () {
      _me.jie_zidongFlag = false;
      _me.jie_wulianFlag = true;
      _me.jie_nengyuanFlag = false;
      _me.jie_huanjingFlag = false;
      _me.jie_index = false;
      _me.activeNav = 2;
      _me.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
      //  _me.$refs.jie_zidong1.style.zIndex=5
      // _me.$refs.jie_wulian.style.zIndex=10
      // }, 1000);
      // this.jie_zidongFlag = true;
      // this.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
    },
    handleTurnNeng() {
      //解决方案--能源
      var _me = this;
      // setTimeout(function () {
      _me.jie_zidongFlag = false;
      _me.jie_wulianFlag = false;
      _me.jie_nengyuanFlag = true;
      _me.jie_huanjingFlag = false;
      _me.jie_index = false;
      _me.activeNav = 3;
      _me.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
      //  _me.$refs.jie_zidong1.style.zIndex=5
      // _me.$refs.jie_wulian.style.zIndex=10
      // }, 1000);
      // this.jie_zidongFlag = true;
      // this.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
    },
    handleTurnHuan() {
      //解决方案--环境
      var _me = this;
      // setTimeout(function () {
      _me.jie_zidongFlag = false;
      _me.jie_wulianFlag = false;
      _me.jie_nengyuanFlag = false;
      _me.jie_huanjingFlag = true;
      _me.jie_index = false;
      _me.activeNav = 4;
      _me.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
      //  _me.$refs.jie_zidong1.style.zIndex=5
      // _me.$refs.jie_wulian.style.zIndex=10
      // }, 1000);
      // this.jie_zidongFlag = true;
      // this.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
    },
    handleTurnJieIndex() {
      //解决方案--首页
      var _me = this;
      _me.jie_zidongFlag = false;
      _me.jie_wulianFlag = false;
      _me.jie_nengyuanFlag = false;
      _me.jie_huanjingFlag = false;
      _me.jie_index = true;
      _me.activeNav = -1;
      _me.$refs.fullpage.api.setAllowScrolling(true, "up,down,left, right");
    },
    // 产品中心--工业软件
    handleTurnRuan() {
      var _me = this;
      _me.chan_gongFlag = true;
      _me.chan_wuxianFlag = false;
      _me.chan_yiqiFlag = false;
      _me.chan_index = false;
      _me.activeNav = 1;
      _me.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
    },
    // 产品中心--工业无线
    handleTurnWuXian() {
      var _me = this;
      _me.chan_gongFlag = false;
      _me.chan_wuxianFlag = true;
      _me.chan_yiqiFlag = false;
      _me.chan_index = false;
      _me.activeNav = 2;
      _me.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
    },
    // 产品中心--仪器仪表
    handleTurnYi() {
      var _me = this;
      _me.chan_gongFlag = false;
      _me.chan_wuxianFlag = false;
      _me.chan_yiqiFlag = true;
      _me.chan_index = false;
      _me.activeNav = 3;
      _me.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
    },
    // 产品中心--首页
    handleTurnChanIndex() {
      var _me = this;
      _me.chan_gongFlag = false;
      _me.chan_wuxianFlag = false;
      _me.chan_yiqiFlag = false;
      _me.chan_index = true;
      _me.activeNav = -1;
      _me.$refs.fullpage.api.setAllowScrolling(true, "up,down,left, right");
    },
    // 咨询服务--咨询
    handleTurnZi() {
      var _me = this;
      _me.zi_zixunFlag = true;
      _me.zi_fuwuFlag = false;
      _me.zi_index = false;
      _me.activeNav = 1;
      _me.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
    },
    // 咨询服务--服务
    handleTurnFu() {
      var _me = this;
      _me.zi_zixunFlag = false;
      _me.zi_fuwuFlag = true;
      _me.zi_index = false;
      _me.activeNav = 2;
      _me.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
    },
    // 咨询服务--首页
    handleTurnZiIndex() {
      var _me = this;
      _me.zi_zixunFlag = false;
      _me.zi_fuwuFlag = false;
      _me.zi_index = true;
      _me.activeNav = -1;
      _me.$refs.fullpage.api.setAllowScrolling(true, "up,down,left, right");
    },
    //跳往解决方案二级页面
    handleJieSecond() {
      this.$router.push("/solution");
    },
    //跳往解决方案--自动化三级页面
    handleZidong() {
      this.$router.push("/automation");
    },
    //跳往解决方案--自动化三级页面
    handlewulian() {
      this.$router.push("/iot");
    },
    //跳往解决方案--能源三级页面
    handleNengyuan() {
      this.$router.push("/energy");
    },
    //跳往解决方案--环境三级页面
    handleHuanjing() {
      this.$router.push("/environmental");
    },
    //跳往产品中心二级页面
    handleChanSecond() {
      this.$router.push("/productCenter");
    },
    //跳往产品中心--工业软件页面
    handleChanGongruan() {
      this.$router.push("/industrialSoft");
    },
    //跳往产品中心---工业无线页面
    handleChanGongwu() {
      this.$router.push("/industrialWir");
    },
    //跳往产品中心---测量仪表页面
    handleChanCe() {
      this.$router.push("/measuring");
    },
    //跳往咨询服务二级页面
    handleZiSecond() {
      this.$router.push("/consulting");
    },
    //跳往咨询服务--咨询三级页面
    handleZixun() {
      this.$router.push("/consultSer");
    },
    //跳往咨询服务--服务三级页面
    handleFuwu() {
      this.$router.push("/servicing");
    },
    //跳往专长页面
    handleZhuanSecond() {
      this.$router.push("/expertise");
    },
    //跳往了解我们页面
    handleLiaoSecond() {
      this.$router.push("/knowus");
    },
    // 键盘事件
    handleKeyup(event) {
      const e = event || window.event || arguments.callee.caller.arguments[0];
      if (!e) return;
      // const { key, keyCode } = e;
      // console.log(keyCode);
      // console.log(key);
    },
    //  滑轮事件
    handleScroll() {
      var e = document.body.scrollTop || document.documentElement.scrollTop;
      if (!e) return;
      // console.log(e);
    },
    // 解决方案-自动轮播
    handleSlide() {
      var _me = this;
      setInterval(function () {
        // _me.$refs.fullpage.api.moveSectionDown();
        _me.handleKeyup();
        _me.handleScroll();
      }, 2000);
    },
    // 自动轮播销毁
    destroyed() {
      window.removeEventListener("keyup", this.handleKeyup);
      window.removeEventListener("scroll", this.handleScroll);
    },
    handlebeforeEnter(el) {
      el.style.opacity = 1;
      // console.log(111)
    },
    handleEnter(el, done) {
      el.style.opacity = 1;
      // el.style.transform='translatex(100px)'
      // el.style.transition="all 10s"
      done();
      //   setTimeout(() => {
      //  el.style.left =10;
      //   console.log(222)

      //   }, 1000);
      //   setTimeout(() => {
      //     //这里的done回调函数也比较重要，done函数触发完又会触发@after-ender
      //     done();
      //   },2000);
    },
    handleafterEnter(el) {
      el.style.opacity = 1;
      console.log(333);
    },
  },
};
</script>

<style lang='scss' scoped>
.home {
  width: 100%;
  height: 100%;
}
#animate_active {
  transition: all 0.3s ease-in-out; //这是滑入划出的动画
}
.nav_ul {
  transition: all 0.6s ease-in-out; //这是滑入划出的动画
}
.header {
  width: 100%;
  height: 100px;
  // padding-top: 10px;
  // padding-bottom: 10px;
  border-bottom: 1px solid white;
  border-bottom-color: rgba(255, 255, 255, 0.2);
  // position: fixed;
  // top: 0;
  .header_center {
    width: 95%;
    height: 100px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    .logo {
      cursor: pointer;
      width: 371px;
      height: 55px;
      // height: 100%;
    }
    ul {
      height: 100px;
      width: 40%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .beforeItem {
        box-sizing: border-box;
        height: 100px;
        line-height: 100px;
        cursor: pointer;
        // z-index: 999;
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        float: left;
      }
      li {
        box-sizing: border-box;
        height: 100px;
        line-height: 100px;
        cursor: pointer;
        // z-index: 999;
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        float: left;
      }
    }
    .header_right {
      width: 8%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .division {
        display: inline-block;
        width: 2px;
        height: 36px;
        background: rgba(228, 228, 228, 1);
        // margin-top: 30px;
        // margin-right: 46px;
      }
      img {
        width: 20px;
      }
      .sou {
        // margin-right: 44px;
        // margin-top: 37px;
      }
      .dao {
        // margin-top: 38px;
      }
    }
  }
}
.headerChange {
  background: white;
  width: 100%;
  height: 100px;
  border-bottom: 1px solid white;
  border-bottom-color: rgba(255, 255, 255, 0.2);
  // position: sticky;
  // top: 0;
  .header_center {
    width: 95%;
    height: 100px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      cursor: pointer;
      width: 371px;
      height: 55px;
    }
    ul {
      height: 100px;
      width: 40%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      li {
        box-sizing: border-box;
        height: 100%;
        line-height: 100px;
        cursor: pointer;
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #333333;
        float: left;
      }
    }
    .header_right {
      width: 8%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .division {
        display: inline-block;
        width: 2px;
        height: 36px;
        background: rgba(228, 228, 228, 1);
        //       // margin-top: 30px;
        //       // margin-right: 46px;
      }
      img {
        width: 20px;
      }
      .sou {
        //       // margin-right: 44px;
        //       // margin-top: 37px;
      }
      .dao {
        //       // margin-top: 38px;
      }
    }
  }
}
.activeItem {
  height: 100px !important;
  span {
    color: rgba(220, 186, 121, 1) !important;
  }
  border-bottom: 3px solid rgba(220, 186, 121, 1) !important;
}
.nav {
  width: 100%;
  background: rgba(0, 0, 0, 1);
  opacity: 0.8;
  position: absolute;
  top: 100px;
  .nav_ul {
    padding: 30px 220px;
    display: flex;
    justify-content: center;
    .nav_li {
      cursor: pointer;
      list-style: disc;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      margin-right: 220px;
      &:nth-last-child(1) {
        margin-right: 0px;
      }
    }
    span {
      display: block;
      margin-top: 15px;
      margin-bottom: 10px;
      cursor: pointer;
    }
  }
}
.first_span {
  font-size: 16px;
}
.sec_span{
  text-indent:16px;
}
.modal {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 1);
  opacity: 0.8;
  z-index: 1;
  padding-top: 7px;
  .modal_center {
    width: 80%;
    height: 100%;
    margin: 0 auto;
    padding: 15px 0px;
    .modal_top {
      margin-bottom: 60px;
      img {
        width: 371px;
        height: 55px;
        cursor: pointer;
      }
    }
  }
  .cha {
    color: white;
    font-size: 30px;
    float: right;
    cursor: pointer;
  }
  span {
    font-size: 18px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    cursor: pointer;
  }
  .all {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  li {
    span {
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      margin-top: 20px;
      display: inline-block;
      cursor: pointer;
    }
  }
  .title {
    margin-bottom: 10px;
  }
}
.section1 {
  background: url("../../assets/img/banner1.jpg") no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  .middle {
    // position: relative;
    // z-index:10;
    .font {
      text-align: center;
      font-size: 48px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      // margin-top: 350px;
      cursor: default;
    }
    .line {
      width: 258px;
      height: 4px;
      background: rgba(255, 255, 255, 1);
      margin: 0 auto;
      margin-top: 30px;
    }
    .letter {
      text-align: center;
      font-size: 17px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: rgba(255, 255, 255, 1);
      margin-top: 30px;
      cursor: default;
    }
  }
}
.section2 {
  width: 100%;
  height: 100%;
  background: url("../../assets/img/banner2.jpg") no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .iconfont {
    font-size: 16px;
  }
  .box4 {
    margin-left: 18%;
  }
  .div1 {
    font-size: 48px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    // padding-top: 17%;
    // padding-left: 18%;
    // margin-bottom: 30px;
    cursor: default;
  }
  .div2 {
    width: 56px;
    height: 6px;
    background: rgba(255, 255, 255, 1);
    // margin-left: 18%;
    margin-top: 35px;
  }
  .div3 {
    font-size: 26px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
    // margin-right: 79%;
    // padding-left: 18%;
    text-align: left;
    margin-top: 35px;
    cursor: default;
  }
  .div4 {
    width: 149px;
    height: 55px;
    background: rgba(220, 186, 121, 1);
    // border: 3px solid rgba(220, 186, 121, 1);
    text-align: center;
    margin-top: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    // margin-left: 18%;
    span {
      font-size: 18px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: rgba(255, 255, 255, 1);
      line-height: 50px;
      cursor: pointer;
    }
  }
  .front {
    transform: translateZ(480px);
    width: 100%;
    height: 100%;
  }
  .top {
    // background: linear-gradient(
    //   0deg,
    //   rgba(2, 79, 155, 1),
    //   rgba(25, 108, 187, 1)
    // );
  }
  .bottom {
    // background: linear-gradient(
    //   0deg,
    //   rgba(2, 79, 155, 1),
    //   rgba(25, 108, 187, 1)
    // );
  }
}
.section3 {
  background: url("../../assets/img/banner3.jpg") no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  .iconfont {
    font-size: 16px;
  }
  // text-align: right;
  .box3 {
    padding-right: 16%;
    // float: right;
    text-align: right;
  }
  .div1 {
    font-size: 48px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    // padding-top: 17%;
    // padding-left: 72%;
    cursor: default;
  }
  .div2 {
    width: 56px;
    height: 6px;
    background: rgba(255, 255, 255, 1);
    display: inline-block;
    // margin-left: 79%;
    margin-top: 35px;
  }
  .div3 {
    font-size: 26px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
    // margin-right: 18%;
    // text-align: right;
    margin-top: 35px;
    cursor: default;
  }
  .div4 {
    width: 149px;
    height: 55px;
    background: rgba(220, 186, 121, 1);
    // border: 3px solid rgba(220, 186, 121, 1);
    text-align: center;
    // display: inline-block;
    margin-top: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    float: right;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // flex-direction: column;
    // margin-left: 74%;
    span {
      font-size: 18px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: rgba(255, 255, 255, 1);
      line-height: 50px;
      cursor: pointer;
    }
  }
  .font2 {
    margin-left: 70% !important;
  }
  .line2 {
    margin-left: 70% !important;
  }
  .letter2 {
    margin-left: 70% !important;
  }
  .top {
    background: linear-gradient(
      0deg,
      rgba(0, 92, 91, 1),
      rgba(136, 177, 127, 1) !important
    );
  }
  .bottom {
    background: linear-gradient(
      0deg,
      rgba(0, 92, 91, 1),
      rgba(136, 177, 127, 1) !important
    );
  }
}
.section4 {
  background: url("../../assets/img/banner4.jpg") no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .iconfont {
    font-size: 16px;
  }
  .box4 {
    margin-left: 18%;
  }
  .div1 {
    font-size: 48px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    // padding-top: 17%;
    // padding-left: 18%;
    // margin-bottom: 30px;
    cursor: default;
  }
  .div2 {
    width: 56px;
    height: 6px;
    background: rgba(255, 255, 255, 1);
    // margin-left: 18%;
    margin-top: 35px;
  }
  .div3 {
    font-size: 26px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
    // margin-right: 79%;
    // padding-left: 18%;
    text-align: left;
    margin-top: 35px;
    cursor: default;
  }
  .div4 {
    width: 149px;
    height: 55px;
    background: rgba(220, 186, 121, 1);
    // border: 3px solid rgba(220, 186, 121, 1);
    text-align: center;
    margin-top: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    // margin-left: 18%;
    span {
      font-size: 18px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: rgba(255, 255, 255, 1);
      line-height: 50px;
      cursor: pointer;
    }
  }
  .front {
    transform: translateZ(470px);
    width: 100%;
    height: 100%;
  }
  .top {
    // background: linear-gradient(
    //   0deg,
    //   rgba(197, 22, 51, 1),
    //   rgba(218, 94, 58, 1)
    // );
  }
  .bottom {
    // background: linear-gradient(
    //   0deg,
    //   rgba(197, 22, 51, 1),
    //   rgba(218, 94, 58, 1)
    // );
  }
}
.section5 {
  // height: 555px !important;
  width: 100%;
  background: rgba(51, 50, 52, 1) !important;
}
.bottom_border {
  width: 100%;
  border-bottom: 1px solid rgba(59, 59, 60, 1);
}
.bottom_center {
  width: 75%;
  // height: 310px;
  margin: 0 auto;
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
  ul {
    // float: left;
    // margin-right: 183px;
    &:nth-last-child(1) {
      margin-right: 0px;
    }
    li {
      cursor: pointer;
      span {
        cursor: pointer;
      }
      &:nth-child(1) {
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: rgba(127, 127, 127, 1);
      margin-bottom: 25px;
      .foot_title {
        color: rgba(255, 255, 255, 1) !important;
        cursor: pointer;
      }
    }
  }
  .zixun {
    margin-bottom: 25px;
  }
  .zhuanchang {
    letter-spacing: 29px;
  }
}
.contact {
  width: 100%;
  border-bottom: 1px solid rgba(59, 59, 60, 1);
}
.contact_center {
  width: 75%;
  // height: 150px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin: 0 auto;
  position: relative;
  .font {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    padding-bottom: 28px;
    cursor: default;
  }
  .contact_phone {
    img {
      // width: 15px;
      margin-right: 14px;
    }
    span {
      cursor: default;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: rgba(153, 153, 153, 1);
    }
  }
  .contact_phone1 {
    margin-bottom: 18px;

    display: flex;
    align-items: center;
    img {
      width: 15px;
      height: 18px;
    }
    .phone1 {
      margin-right: 58px;
    }
    .chuanzhen {
      // margin-top:3px
    }
  }
  .contact_phone2 {
    display: flex;
    align-items: center;
    img {
      width: 15px;
      height: 18px;
    }
    .phone2 {
      margin-right: 58px;
    }
    .chuanzhen {
      // margin-top:3px
    }
    .dizhi {
      width: 12px;
      height: 18px;
      margin-right: 17px;
      // margin-right: ;
    }
  }
  .image_er {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .erweima {
    // position: absolute;
    // right: 0;
    // top: 50%;
    width: 87px;
    height: 87px;
  }
}
.power {
  text-align: center;
  padding-bottom: 20px;
  // height: 200px;
  span {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: rgba(153, 153, 153, 1);
    margin-top: 20px;
    display: inline-block;
  }
}
.section.footerss .fp-tableCell {
  display: block !important;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
//modal进入和离开的动画时间段
.modal-enter-active,
.modal-leave-active {
  transition: all 0.5s ease;
}
.aa {
  transition: all 0.5s;
}
.go {
  transform: rotate(180deg);
  transition: all 0.5s;
}
#menu {
  position: fixed;
  z-index: 1000;
  top: 0;
  width: 100%;
  height: 100px;
  // z-index: 100;
}
.jie_zidong {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  .jie_zidong_right {
    width: 50%;
    height: 100%;
    float: right;
  }

  @-webkit-keyframes left {
    0% {
      -webkit-transform: rotateX(180deg);
      opacity: 0;
    }
    60% {
      -webkit-transform: rotateX(20deg);
    }
    70% {
      -webkit-transform: rotateX(15deg);
    }
    80% {
      -webkit-transform: rotateX(-15deg);
    }
    85% {
      -webkit-transform: rotateX(10deg);
    }
    90% {
      -webkit-transform: rotateX(-10deg);
    }
    100% {
      -webkit-transform: rotateX(0);
      opacity: 1;
    }
  }
  @-webkit-keyframes right {
    0% {
      -webkit-transform: rotateX(-180deg);
      opacity: 0;
    }
    60% {
      -webkit-transform: rotateX(-20deg);
    }
    70% {
      -webkit-transform: rotateX(-15deg);
    }
    80% {
      -webkit-transform: rotateX(15deg);
    }
    85% {
      -webkit-transform: rotateX(-10deg);
    }
    90% {
      -webkit-transform: rotateX(10deg);
    }
    100% {
      -webkit-transform: rotateX(0);
      opacity: 1;
    }
  }
}
.jie_zidong1 {
  // .bottom {
  //   transform: rotateX(-90deg) translateY(53%) translateZ(90%)!important;
  // }
  // .jie_zidong_right {
  //   .top {
  //     display: flex;
  //     justify-content: center;
  //     align-items: center;
  //   }
  // }
  .front {
    transform: translateZ(505px) !important;
  }
}
.jie_wulian {
  .top {
    background: rgba(255, 255, 255, 1);
    transform: rotateX(90deg) translateY(-53%);
  }
  .bottom {
    background: rgba(255, 255, 255, 1);
    transform: rotateX(-90deg) translateY(53%);
  }
  .font {
    color: rgba(51, 51, 51, 1) !important;
  }
  .letter {
    color: rgba(51, 51, 51, 1) !important;
  }
  .jie_zidong_right {
    .front {
      // transform: translateZ(-20%) !important;
    }
  }
}
.jie_nengyuan {
  .front {
    transform: translateZ(505px) !important;
  }
}
.jie_huanjing {
  .top {
    background: rgba(255, 255, 255, 1);
    transform: rotateX(90deg) translateY(-53%);
  }
  .bottom {
    background: rgba(255, 255, 255, 1);
    transform: rotateX(-90deg) translateY(53%);
  }
  .font {
    color: rgba(51, 51, 51, 1) !important;
  }
  .letter {
    color: rgba(51, 51, 51, 1) !important;
  }
}
.jie_index {
  // position: relative;
  img {
    position: absolute;
    width: 100%;
  }
  // .top {

  .box4_index {
    display: flex;
    flex-direction: column;
    // align-items:flex-end;
    justify-content: center;
    // float: right;
    // margin-right: 5%;
    position: relative;
    right: -40%;
    z-index: 100;
  }
  // .div1 {
  //   padding-top: 35%;
  //   padding-left: 34%;
  // }
  // .div2 {
  //   margin-left: 34%;
  //   margin-top: 45%;
  // }
  // .div3 {
  //   padding-left: 34%;
  //   margin-top: 49%;
  // }
  // .div4 {
  //   margin-top: 62%;
  //   margin-left: 34%;
  // }
  // }
  // .top {
  //     transform: rotateX(90deg) translateX(-53%);
  //   }
  // .bottom {
  //   transform: rotateX(-90deg) translateX(53%);
  // }
  .front {
    // transform: translateZ(505px) !important;
  }
}
.chan_wuxian {
  .front {
    transform: translateZ(481px);
    width: 100%;
    height: 100%;
  }
  .top {
    transform: rotateX(90deg) translateY(-53%);
  }
  .bottom {
    transform: rotateX(-90deg) translateY(53%);
  }
}
.chan_index {
  .bottom {
    .div1 {
      padding-top: 35%;
      padding-left: 45%;
    }
    .div2 {
      margin-left: 59%;
      margin-top: 45%;
    }
    .div3 {
      position: absolute;
      right: 17%;
      top: 43%;
    }
    .div4 {
      margin-top: 62%;
      margin-left: 49%;
    }
  }
}
.zi_zixun {
  .front {
    transform: translateZ(505px) !important;
  }
}
.zi_fuwu {
  .top {
    background: rgba(255, 255, 255, 1);
    transform: rotateX(90deg) translateY(-53%);
  }
  .bottom {
    background: rgba(255, 255, 255, 1);
    transform: rotateX(-90deg) translateY(53%);
  }
}
.zi_index {
  img {
    position: absolute;
    width: 100%;
  }
  .top {
    .div1 {
      padding-top: 35%;
      padding-left: 34%;
    }
    .div2 {
      margin-left: 34%;
      margin-top: 45%;
    }
    .div3 {
      padding-left: 34%;
      margin-top: 49%;
    }
    .div4 {
      margin-top: 62%;
      margin-left: 34%;
    }
  }
  .front {
    transform: translateZ(505px) !important;
  }
}
.wrap {
  float: left;
  width: 50%;
  height: 100%;
  perspective: 15000px; //调节景深问题
  // perspective-origin: center center;
  // transform-origin: center center center center center center;
  // width: 50%;
  // height: 100%;
}
.cube {
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  // top: 500px;
}
.top_span {
  display: flex !important;
  flex-direction: column;
  // justify-content: center;
  // margin-top: 42%;
  position: absolute;
  // right: 50px;
  top: 38%;
  left: 8%;
  // margin-left: 5%;
  // align-items: center;
}
.top_span_left {
  display: flex !important;
  flex-direction: column;
  // justify-content: center;
  // margin-top: 42%;
  position: absolute;
  right: 5%;
  // right: 50px;
  top: 38%;
  // left: 5%;
  // margin-left: 5%;
  // align-items: center;
}

.cube div {
  position: absolute;
  width: 100%;
  height: 100%;
  //  transition-delay: 3s;
  img {
    width: 100%;
    height: 100%;
  }
  .font {
    font-size: 28px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    // line-height: 30px;
    margin-bottom: 35px;
    // margin-left: 5%;
    // padding: 40% 0px 15px;
    // transform: rotateZ(-180deg);
  }
  .line {
    width: 26px;
    height: 3px;
    background: rgba(220, 186, 121, 1);
    margin-bottom: 30px;
    // margin-left: 5%;
    // margin-top: 46%;
  }
  .letter {
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    // margin-left: 5%;
    // line-height: 25px;
    // margin-top: 48%;
  }
  .font1 {
  }
}
.back {
  transform: translateZ(-504px);
  width: 100%;
  height: 100%;
}
.top {
  transform: rotateX(90deg) translateY(-50%);
  transform-origin: top center;
  width: 100%;
  height: 100%;
}
.bottom {
  transform: rotateX(-90deg) translateY(50%);
  transform-origin: bottom center;
  width: 100%;
  height: 100%;
}
.front {
  // transform: translateZ(481px);
  transform: translateZ(504px);
  width: 100%;
  height: 100%;
}
.left {
  transform: rotateY(270deg) translateX(-50%);
  transform-origin: center left;
  width: 100%;
  height: 100%;
}
.right {
  transform: rotateY(-270deg) translateX(50%);
  transform-origin: top right;
  width: 100%;
  height: 100%;
}
@keyframes spin_left {
  from {
    transform: rotateX(0);
  }
  to {
    transform: rotateX(90deg);
  }
}
@keyframes spin_right {
  from {
    transform: rotateX(0);
  }
  to {
    transform: rotateX(-90deg);
  }
}
@keyframes spin_wulianLeft {
  from {
    transform: rotateY(0);
  }
  to {
    transform: rotateY(90deg);
  }
}
@keyframes spin_wulianRight {
  from {
    transform: rotateY(0);
  }
  to {
    transform: rotateY(-90deg);
  }
}
.cube {
  animation: spin_left 1s 1 0.1s alternate ease-in-out forwards;
}
.cube_right {
  animation: spin_right 1s 1 0.1s alternate ease-in-out forwards;
}
.cube_wulianLeft {
  animation: spin_wulianLeft 1s 1 0.1s alternate ease-in-out forwards;
}
.cube_wulianRight {
  animation: spin_wulianRight 1s 1 0.1s alternate ease-in-out forwards;
}
// 解决方案二级侧边栏
.nav_list {
  position: absolute;
  right: 50px;
  top: 42%;
  z-index: 1000;
  div {
    display: inline-block;
  }
  .span_right {
    margin-left: 15px;
  }
  b {
    display: inline-block;
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    transition: all 0.2s;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    letter-spacing: 1px;
    border-right: 1px rgba(255, 255, 255, 1) solid;
    padding-right: 13px;
  }
  li {
    cursor: pointer;
  }
}
// 产品中心
.nav_list2 {
  left: 50px;
  display: inline-block;
  i {
    margin-right: 10px;
  }
  b {
    border-right: none;
    border-left: 1px rgba(255, 255, 255, 1) solid;
    padding-left: 13px;
    padding-right: 0px;
  }
}
.activeNameList1 {
  transition: all 0.2s;
  b {
    color: rgba(51, 51, 51, 1);
    border-right: 1px rgba(51, 51, 51, 1) solid;
  }
}
.activeNameList2 {
  transition: all 0.2s;
  b {
    color: rgba(51, 51, 51, 1);
    border-left: 1px rgba(51, 51, 51, 1) solid;
  }
}
.activeName1 {
  color: rgba(220, 186, 121, 1) !important;
  border-right: 1px solid rgba(220, 186, 121, 1) !important;
}
.activeName2 {
  color: rgba(220, 186, 121, 1) !important;
  border-left: 1px solid rgba(220, 186, 121, 1) !important;
}
@keyframes fade-in {
  0% {
    opacity: 1;
  } /*初始状态 透明度为0*/
  40% {
    opacity: 1;
  } /*过渡状态 透明度为0*/
  100% {
    opacity: 1;
  } /*结束状态 透明度为1*/
}
@-webkit-keyframes fade-in {
  /*针对webkit内核*/
  0% {
    opacity: 1;
  }
  40% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
.box {
  animation: fade-in; /*动画名称*/
  animation-duration: 0s; /*动画持续时间*/
  -webkit-animation: fade-in 0s; /*针对webkit内核*/
}
.btn-2:hover,
.btn-2:active {
  letter-spacing: 3px;
}

.btn-2:after,
.btn-2:before {
  backface-visibility: hidden;
  border: 1px solid rgba(#fff, 0);
  bottom: 0px;
  content: " ";
  display: block;
  margin: 0 auto;
  position: relative;
  transition: all 280ms ease-in-out;
  width: 0;
}

.btn-2:hover:after,
.btn-2:hover:before {
  backface-visibility: hidden;
  border-color: #fff;
  transition: width 350ms ease-in-out;
  width: 98%;
}

.btn-2:hover:before {
  bottom: auto;
  top: 0;
  width: 98%;
}
</style>
